import { normalizeCertificates } from './normalizeCertificates'
import { normalizePozycje } from './normalizePozycje'

const aggregateCertificatesFromPozycje = pozycje => {
	const seen = new Set()
	const aggregated = []
	for (const item of pozycje) {
		for (const certificate of normalizeCertificates(item.certificates)) {
			if (seen.has(certificate.certificateId)) continue
			seen.add(certificate.certificateId)
			aggregated.push(certificate)
		}
	}
	return aggregated
}

export const buildProjectStepPayload = (form, placowka) => {
	const pozycje = normalizePozycje(form.pozycje)
	const certificatesFromPozycje = aggregateCertificatesFromPozycje(pozycje)
	const certificates = certificatesFromPozycje.length
		? certificatesFromPozycje
		: normalizeCertificates(form.certificates)

	return {
		nazwa: form.nazwa?.trim() || '',
		placowkaId: placowka?._id || placowka?.id || '',
		placowkaName: placowka?.nazwa || '',
		certificates,
		data_rozpoczecia: form.data_rozpoczecia || '',
		data_zakonczenia: form.data_zakonczenia || form.data_rozpoczecia || '',
		godzina_rozpoczecia: form.startTime || '',
		godzina_zakonczenia: form.endTime || '',
		adres: form.ulica?.trim() || '',
		miasto: form.miasto?.trim() || '',
		kod_pocztowy: form.kod_pocztowy?.trim() || '',
		g_placeid: form.g_placeid || '',
		g_lat: form.g_lat === '' || form.g_lat == null ? '' : form.g_lat,
		g_long: form.g_long === '' || form.g_long == null ? '' : form.g_long,
		status: form.status || 'new',
		notatki: form.notatki?.trim() || '',
		osoba_kontaktowa: {
			nazwisko: form.osoba_kontaktowa?.nazwisko?.trim() || '',
			funkcja: form.osoba_kontaktowa?.funkcja?.trim() || '',
			telefon: form.osoba_kontaktowa?.telefon?.trim() || '',
		},
		pozycje,
		startTime: form.startTime || '',
		endTime: form.endTime || '',
	}
}
